<template>
  <div class="candidate-dashboard mb-3">
    <div v-if="getCustomerTypeIDFromAccessToken === 7">
      <CTabs :activeTab="tabIndex" @update:activeTab="handleTabChange">
        <CTab title="Marketplace">
          <MarketPlaceDashboard />
        </CTab>
        <CTab title="KSA Region">
          <div class="mt-2" >
            <div
              v-if="
                (currentUserRole == Role.customerAdmin ||
                  currentUserRole == Role.customerRecruiter) &&
                !isEducationalInstitute
              "
            >
              <CRow class="widget-v2">
                <CCol md="9">
                  <CRow>
                    <div
                      class="col-md-4"
                      v-for="(
                        { id, label, value }, index
                      ) in getCandidateData.stats"
                      :key="index"
                    >
                      <div
                        class="card card-raised border-start border-4"
                        :style="`border-color: ${getTheme(id).raw_color}`"
                      >
                        <div class="card-body pl-4 pr-4">
                          <div
                            class="d-flex justify-content-between align-items-center mb-2"
                          >
                            <div class="me-2">
                              <div class="display-5">{{ value }}</div>
                              <div
                                class="card-text"
                                :style="getTheme(id).text_color"
                              >
                                {{ label }}
                              </div>
                            </div>
                            <i
                              v-if="iconHide(id)"
                              :class="getTheme(id).src"
                              style="font-size: 27px"
                              :style="getTheme(id).text_color"
                            />
                            <img
                              v-else
                              :src="getTheme(id).src"
                              class="icon-img"
                              :style="getTheme(id).text_color"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </CRow>
                </CCol>
                <CCol md="3">
                  <CRow>
                    <div
                      class="col-md-12 border-left"
                      v-for="(
                        { id, label, value }, index
                      ) in getCandidateData.totalData"
                      :key="index"
                    >
                      <div
                        class="card card-raised border-start border-4"
                        :style="`border-color: ${getTheme(id).raw_color}`"
                      >
                        <div class="card-body pl-4 pr-4">
                          <div
                            class="d-flex justify-content-between align-items-center mb-2"
                          >
                            <div class="me-2">
                              <div class="display-5">{{ value }}</div>
                              <div
                                class="card-text"
                                :style="getTheme(id).text_color"
                              >
                                {{ label }}
                              </div>
                            </div>
                            <i
                              v-if="iconHide(id)"
                              :class="getTheme(id).src"
                              style="font-size: 27px"
                              :style="getTheme(id).text_color"
                            />
                            <img
                              v-else
                              :src="getTheme(id).src"
                              class="icon-img"
                              :style="getTheme(id).text_color"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </CRow>
                </CCol>
              </CRow>
            </div>
            <div v-else-if="isEducationalInstitute">
              <CRow class="widget-v2">
                <CCol md="9">
                  <CRow>
                    <div
                      class="col-md-3"
                      v-for="(
                        { id, label, value }, index
                      ) in getCandidateData.stats"
                      :key="index"
                    >
                      <div
                        class="card card-raised border-start border-4"
                        :style="`border-color: ${getTheme(id).raw_color}`"
                      >
                        <div class="card-body pl-4 pr-4">
                          <div
                            class="d-flex justify-content-between align-items-center mb-2"
                          >
                            <div class="me-2">
                              <div class="display-5">{{ value }}</div>
                              <div
                                class="card-text"
                                :style="getTheme(id).text_color"
                              >
                                {{ label }}
                              </div>
                            </div>
                            <i
                              v-if="iconHide(id)"
                              :class="getTheme(id).src"
                              style="font-size: 27px"
                              :style="getTheme(id).text_color"
                            />
                            <img
                              v-else
                              :src="getTheme(id).src"
                              class="icon-img"
                              :style="getTheme(id).text_color"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </CRow>
                </CCol>
                <CCol md="3">
                  <CRow>
                    <div
                      class="col-md-12 border-left"
                      v-for="(
                        { id, label, value }, index
                      ) in getCandidateData.totalData"
                      :key="index"
                    >
                      <div
                        class="card card-raised border-start border-4"
                        :style="`border-color: ${getTheme(id).raw_color}`"
                      >
                        <div class="card-body pl-4 pr-4">
                          <div
                            class="d-flex justify-content-between align-items-center mb-2"
                          >
                            <div class="me-2">
                              <div class="display-5">{{ value }}</div>
                              <div
                                class="card-text"
                                :style="getTheme(id).text_color"
                              >
                                {{ label }}
                              </div>
                            </div>
                            <i
                              v-if="iconHide(id)"
                              :class="getTheme(id).src"
                              style="font-size: 27px"
                              :style="getTheme(id).text_color"
                            />
                            <img
                              v-else
                              :src="getTheme(id).src"
                              class="icon-img"
                              :style="getTheme(id).text_color"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </CRow>
                </CCol>
              </CRow>
              <MoodleCourseDashboard />
              <MoodleCoursesProgressChart /> 
            </div>
            <div class="tile" v-else>
              <Tile
                :jobTotalCount="getJobTotalCount"
                :shortlistCount="getDashboardMetrics.SHORTLIST"
                :interviewCount="getDashboardMetrics.INTERVIEW"
                :recruitCount="getTotalCount"
              />
            </div>
            <CCard>
              <CCardHeader>
                <CRow class="card-header-title d-flex align-items-center pl-3">
                  <h5 class="text-primary">Full & Short Registrations</h5>
                </CRow>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md="6">
                    <div class="position-relative" style="height: 250px">
                      <GPie v-if="getCandidateFullShortStats.length" :data="getCandidateFullShortStats" :keys="['Full', 'Short']" :height="'220px'" />  
                    </div>
                  </CCol>
                  <CCol md="6">
                    <div
                      class="position-relative mx-auto"
                      style="height: 250px"
                    >
                      <BasicBar :data="getCandidateFullShortTrend" />
                    </div>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>

            <CCard>
              <CCardHeader>
                <CRow class="card-header-title d-flex align-items-center pl-3">
                  <h5 class="text-primary">Registered Candidates by Country</h5>
                </CRow>
              </CCardHeader>
              <CCardBody>
                <GeoChart v-if="getCandidateByCountry.length"  :candidates="getCandidateByCountry" />
              </CCardBody>
            </CCard>

            <CRow v-if="!isEducationalInstitute">
              <CCol lg="12">
                <CCard>
                  <CCardHeader>
                    <CRow
                      class="card-header-title d-flex align-items-center pl-3"
                    >
                      <h5 class="text-primary">Job Sub Status</h5>
                    </CRow>
                  </CCardHeader>
                  <CCardBody
                    class="d-flex justify-content-center align-items-center"
                  >
                    <CRow>
                      <CCol lg="5" id="leftChart">
                        <CustomPieChart
                          class="col-12"
                          :PieChartData="getTabTotalCounts"
                          :PieChartLegendData="getTabTotalCounts"
                          :isFromJobStatus="true"
                        />
                      </CCol>
                      <CCol lg="7" id="rightChart">
                        <CustomPieChart
                          class="col-12"
                          :PieChartData="getTabStatusTotalCounts"
                          :PieChartLegendData="getTabStatusTotalCounts"
                          :isFromJobStatus="true"
                        />
                      </CCol>
                    </CRow>
                  </CCardBody>
                  <div id="jcp"></div>
                </CCard>
              </CCol>
            </CRow>
            <CRow v-if="!isEducationalInstitute">
              <CCol>
                <CandidateJobAlert
                  :shortlistCandidates="getshortlistcandidates"
                />
              </CCol>
            </CRow>
            <div>
              <Transactions />
            </div>
            <CRow>
              <CCol
                lg="6"
                sm="12"
                v-if="isEducationalInstitute && hasStudents"
                style=""
              >
                <CCard class="p-4">
                  <Bar
                    :data="studentChartData"
                    :height="384"
                    graphTitle="Students"
                  />
                </CCard>
              </CCol>
              <CCol
                lg="6"
                sm="12"
                v-if="isEducationalInstitute && hasCourses"
                style=""
              >
                <CCard class="p-4">
                  <Bar
                    :data="courseChartData"
                    :height="384"
                    graphTitle="Courses"
                  />
                </CCard>
              </CCol>
              <CCol
                lg="6"
                sm="12"
                class="d-flex flex-column"
                v-if="!isEducationalInstitute"
              >
                <ScratchPad />
              </CCol>
              <CCol lg="6" sm="12" v-if="!isEducationalInstitute">
                <CalendarPad :events="interviewEvents" />
              </CCol>
            </CRow>
          </div>
        </CTab>
        <CTab title="Application Analysis">
          <KSADashboard />
        </CTab>
        <CTab title="Clinical Placements">
          <ClinicalPlacementsDashboard/>
        </CTab>
      </CTabs>
    </div>
    <div v-else>
      <div class="mt-2">
        <div
          v-if="
            (currentUserRole == Role.customerAdmin ||
              currentUserRole == Role.customerRecruiter) &&
            !isEducationalInstitute
          "
        >
          <CRow class="widget-v2">
            <CCol md="9">
              <CRow>
                <div
                  class="col-md-4"
                  v-for="(
                    { id, label, value }, index
                  ) in getCandidateData.stats"
                  :key="index"
                >
                  <div
                    class="card card-raised border-start border-4"
                    :style="`border-color: ${getTheme(id).raw_color}`"
                  >
                    <div class="card-body pl-4 pr-4">
                      <div
                        class="d-flex justify-content-between align-items-center mb-2"
                      >
                        <div class="me-2">
                          <div class="display-5">{{ value }}</div>
                          <div
                            class="card-text"
                            :style="getTheme(id).text_color"
                          >
                            {{ label }}
                          </div>
                        </div>
                        <i
                          v-if="iconHide(id)"
                          :class="getTheme(id).src"
                          style="font-size: 27px"
                          :style="getTheme(id).text_color"
                        />
                        <img
                          v-else
                          :src="getTheme(id).src"
                          class="icon-img"
                          :style="getTheme(id).text_color"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </CRow>
            </CCol>
            <CCol md="3">
              <CRow>
                <div
                  class="col-md-12 border-left"
                  v-for="(
                    { id, label, value }, index
                  ) in getCandidateData.totalData"
                  :key="index"
                >
                  <div
                    class="card card-raised border-start border-4"
                    :style="`border-color: ${getTheme(id).raw_color}`"
                  >
                    <div class="card-body pl-4 pr-4">
                      <div
                        class="d-flex justify-content-between align-items-center mb-2"
                      >
                        <div class="me-2">
                          <div class="display-5">{{ value }}</div>
                          <div
                            class="card-text"
                            :style="getTheme(id).text_color"
                          >
                            {{ label }}
                          </div>
                        </div>
                        <i
                          v-if="iconHide(id)"
                          :class="getTheme(id).src"
                          style="font-size: 27px"
                          :style="getTheme(id).text_color"
                        />
                        <img
                          v-else
                          :src="getTheme(id).src"
                          class="icon-img"
                          :style="getTheme(id).text_color"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CRow>
        </div>
        <div v-else-if="isEducationalInstitute">
          <CRow class="widget-v2">
            <div
              class="col-md-4"
              v-for="({ id, label, value }, index) in getCandidateData.stats"
              :key="index"
            >
              <div
                class="card card-raised border-start border-4"
                :style="`border-color: ${getTheme(id).raw_color}`"
              >
                <div class="card-body pl-4 pr-4">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <div class="me-2">
                      <div class="display-5">{{ value }}</div>
                      <div class="card-text" :style="getTheme(id).text_color">
                        {{ label }}
                      </div>
                    </div>
                    <i
                      v-if="iconHide(id)"
                      :class="getTheme(id).src"
                      style="font-size: 27px"
                      :style="getTheme(id).text_color"
                    />
                    <img
                      v-else
                      :src="getTheme(id).src"
                      class="icon-img"
                      :style="getTheme(id).text_color"
                    />
                  </div>
                </div>
              </div>
            </div>
          </CRow>
          <MoodleCourseDashboard />
          <MoodleCoursesProgressChart /> 
        </div>
        <div class="tile" v-else>
          <Tile
            :jobTotalCount="getJobTotalCount"
            :shortlistCount="getDashboardMetrics.SHORTLIST"
            :interviewCount="getDashboardMetrics.INTERVIEW"
            :recruitCount="getTotalCount"
          />
        </div>
        <CCard>
          <CCardHeader>
            <CRow class="card-header-title d-flex align-items-center pl-3">
              <h5 class="text-primary">Full & Short Registrations</h5>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="6">
                <div class="position-relative" style="height: 250px">
                  <GPie v-if="getCandidateFullShortStats.length" :data="getCandidateFullShortStats" :keys="['Full', 'Short']" :height="'220px'" />
                </div>
              </CCol>
              <CCol md="6">
                <div class="position-relative mx-auto" style="height: 250px">
                  <BasicBar :data="getCandidateFullShortTrend" />
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardHeader>
            <CRow class="card-header-title d-flex align-items-center pl-3">
              <h5 class="text-primary">Registered Candidates by Country</h5>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <GeoChart v-if="getCandidateByCountry.length"  :candidates="getCandidateByCountry" :height="'500px'" />
          </CCardBody>
        </CCard>

        <CRow v-if="!isEducationalInstitute">
          <CCol lg="12">
            <CCard>
              <CCardHeader>
                <CRow class="card-header-title d-flex align-items-center pl-3">
                  <h5 class="text-primary">Job Sub Status</h5>
                </CRow>
              </CCardHeader>
              <CCardBody
                class="d-flex justify-content-center align-items-center"
              >
                <CRow>
                  <CCol lg="5" id="leftChart">
                    <CustomPieChart
                      class="col-12"
                      :PieChartData="getTabTotalCounts"
                      :PieChartLegendData="getTabTotalCounts"
                      :isFromJobStatus="true"
                    />
                  </CCol>
                  <CCol lg="7" id="rightChart">
                    <CustomPieChart
                      class="col-12"
                      :PieChartData="getTabStatusTotalCounts"
                      :PieChartLegendData="getTabStatusTotalCounts"
                      :isFromJobStatus="true"
                    />
                  </CCol>
                </CRow>
              </CCardBody>
              <div id="jcp"></div>
            </CCard>
          </CCol>
        </CRow>
        <CRow v-if="!isEducationalInstitute">
          <CCol>
            <CandidateJobAlert :shortlistCandidates="getshortlistcandidates" />
          </CCol>
        </CRow>
        <div>
          <Transactions />
        </div>
        <CRow>
          <CCol
            lg="6"
            sm="12"
            v-if="isEducationalInstitute && hasStudents"
            style=""
          >
            <CCard class="p-4">
              <Bar
                :data="studentChartData"
                :height="384"
                graphTitle="Students"
              />
            </CCard>
          </CCol>
          <CCol
            lg="6"
            sm="12"
            v-if="isEducationalInstitute && hasCourses"
            style=""
          >
            <CCard class="p-4">
              <Bar :data="courseChartData" :height="384" graphTitle="Courses" />
            </CCard>
          </CCol>
          <CCol
            lg="6"
            sm="12"
            class="d-flex flex-column"
            v-if="!isEducationalInstitute"
          >
            <ScratchPad />
          </CCol>
          <CCol lg="6" sm="12" v-if="!isEducationalInstitute">
            <CalendarPad :events="interviewEvents" />
          </CCol>
        </CRow>
      </div>
    </div>
  </div>
</template>
<script>
import Tile from "@/containers/Dashboard/RecruiterDashBoard/Tile";
import ScratchPad from "@/containers/Dashboard/RecruiterDashBoard/ScratchPad";
import CalendarPad from "@/containers/Dashboard/RecruiterDashBoard/CalendarPad";
import CandidateJobAlert from "@/containers/Dashboard/RecruiterDashBoard/Alert1-CandidateJobStatus";
import Transactions from "@/containers/Dashboard/RecruiterDashBoard/Transactions";
import RAGAlert from "@/containers/Dashboard/RecruiterDashBoard/Alert2-RAG";
import CandidateCommunication from "@/containers/Dashboard/RecruiterDashBoard/CandidateCommunication";
import { FACILITY_CANDIDATE_URL } from "@/helpers/helper";
import { mapActions, mapGetters } from "vuex";
import { Role, getScope, CONSTANT as CONST } from "@/helpers/helper";
import CustomPieChart from "@/components/Dashboard/CustomPieChart";
import { isObject, isEmptyObjectCheck } from "@/helpers/helper";
import m from "moment";
import Bar from "@/components/reusable/Charts/Bar.vue";
import BasicPie from "@/components/reusable/Charts/BasicPie.vue";
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import GeoChart from "@/components/reusable/Charts/GeoChart.vue";
import KSADashboard from "./KSADashboard.vue";
import MarketPlaceDashboard from "./MarketPlaceDashboard.vue";
import ClinicalPlacementsDashboard from "./ClinicalPlacementsDashboard.vue";
import GPie from "@/components/reusable/Charts/GPie.vue";
import MoodleCourseDashboard from "./MoodleCourseDashboard.vue"
import MoodleCoursesProgressChart from "./MoodleCoursesProgressChart.vue";
export default {
  components: {
    Tile,
    ScratchPad,
    CalendarPad,
    CandidateJobAlert,
    RAGAlert,
    CandidateCommunication,
    CustomPieChart,
    Transactions,
    Bar,
    BasicPie,
    BasicBar,
    GeoChart,
    KSADashboard,
    MarketPlaceDashboard,
    ClinicalPlacementsDashboard,
    GPie,
    MoodleCourseDashboard,
    MoodleCoursesProgressChart
  },
  data() {
    return {
      Role,
      currentUserRole: getScope(),
      candidateData: [
        { country: "India", count: 300 },
        { country: "United States", count: 120 },
        { country: "Canada", count: 80 },
      ],
      fullShortTrend: [
        {
          name: "Full",
          backgroundColor: "rgb(255, 99, 132)",
          values: [
            {
              name: "Jan",
              value: 100,
            },
            {
              name: "Feb",
              value: 210,
            },
            {
              name: "Mar",
              value: 210,
            },
            {
              name: "Apr",
              value: 210,
            },
            {
              name: "May",
              value: 100,
            },
            {
              name: "Jun",
              value: 210,
            },
          ],
        },
        {
          name: "Short",
          backgroundColor: "rgb(54, 162, 235)",
          values: [
            {
              name: "Jan",
              value: 120,
            },
            {
              name: "Feb",
              value: 200,
            },
            {
              name: "Mar",
              value: 210,
            },
            {
              name: "Apr",
              value: 210,
            },
            {
              name: "May",
              value: 100,
            },
            {
              name: "Jun",
              value: 210,
            },
          ],
        },
      ],
      tabIndex: 0,
    };
  },
  computed: {
    ...mapGetters([
      "getCustomerId",
      "getJobTotalCount",
      "getinterviewlistcandidates",
      "getTotalCount",
      "getDashboardMetrics",
      "getShortliststatus",
      "getInterviewstatus",
      "getRecruitstatus",
      "getFacilityConfig",
      "getshortlistcandidates",
      "getCandidateExpiryCount",
      "getScratchPads",
      "getJobCandidateTabs",
      "getTabTotalCounts",
      "getTabStatusTotalCounts",
      "getUser",
      "getCandidateByTypeId",
      "getInterviewSlots",
      "getCustomerTypeIDFromAccessToken",
      "isSuperCustomer",
      "getOrgTypeIDFromAccessToken",
      "getCandidateCourseCount",
      "getOrgID",
      "getEduDashboardStats",
    ]),
    getCandidateFullShortStats() {
      const fullCount =
        this.getCandidateByTypeId?.candidate_stats?.full_registration_summary
          ?.true_count || 0;
      const shortCount =
        this.getCandidateByTypeId?.candidate_stats?.full_registration_summary
          ?.false_count || 0;

      return [
        {
          name: "Full",
          value: fullCount,
          backgroundColor: "#70dbdb",
          borderColor: "#02dbdb",
        },
        {
          name: "Short",
          value: shortCount,
          backgroundColor: "#e381da",
          borderColor: "#b000a0",

        },
      ];
    },

    getCandidateByCountry() {
      const countrySummary =
        this.getCandidateByTypeId?.candidate_stats?.country_summary || [];
      return countrySummary?.map((data) => {
        return {
          name: data.country_name,
          value: data.count,
          country: data.country_name,
          count: data.count,
          backgroundColor: this.getRandomColor(),
        };
      });
    },
    getCandidateFullShortTrend() {
      const monthYearSummary =
        this.getCandidateByTypeId?.candidate_stats?.month_year_summary || [];
      return [
        {
          name: "Full Registration",
          backgroundColor: "#4f8645",
          values: monthYearSummary?.map((data) => {
            return {
              name: data.month_year,
              value: data?.true_count,
            };
          }),
        },
        {
          name: "Short Registration",
          backgroundColor: "#4e94ff",
          values: monthYearSummary?.map((data) => {
            return {
              name: data.month_year,
              value: data?.false_count,
            };
          }),
        },
      ];
    },
    getCandidateData() {
      let getCandidateData =
        this.getCandidateByTypeId &&
        this.getCandidateByTypeId.candidate_stats &&
        this.getCandidateByTypeId.candidate_stats.summary &&
        this.getCandidateByTypeId.candidate_stats.summary.map((data) => {
          const getData = {};
          getData.id = data.candidate_type_id;
          getData.label = data.candidate_type;

          getData.value = data.num_candidates;

          return getData;
        }) || [];
      if (!this.isEducationalInstitute) {
        var totalJob = {
          id: 8,
          label: "Total Jobs Posted",
          value: this.getJobTotalCount,
        };
      } else if (this.isEducationalInstitute) {
        var totalCourses = {
          id: 10,
          label: "Total Courses",
          value: this.getCandidateCourseCount?.courses_count,
        };
        var fully_qualified = {
          id: 11,
          label: "Total Fully Qualified",
          value: this.getCandidateCourseCount.fully_qualified_count,
        };
        var student_count = {
          id: 12,
          label: "Total Students",
          value: this.getCandidateCourseCount.student_count,
        };
        var sponsored_candidates_count = {
          id: 13,
          label: "Sponsored Candidates",
          value: this.getCandidateCourseCount.sponsored_candidates_count,
        };
        // Static values
        var cpd_courses = {
          id: 14,
          label: "CPD Courses",
          value: 5,
        };
      }

      let totalCandidates = {
        id: 9,
        label: "Total Candidates",
        value: this.getTotalCount,
      };
      const totalData = [];
      if (!this.isEducationalInstitute) {
        totalData.push( totalCandidates,totalJob);
        // getCandidateData?.unshift(totalJob, totalCandidates);
      } else {
        // getCandidateData?.unshift(totalCandidates) || [];
        totalData.push(totalCandidates);
        getCandidateData?.push(
          totalCourses,
          fully_qualified,
          student_count,
          sponsored_candidates_count,
          cpd_courses
        ) || [];
      }
      // console.log(getCandidateData)
      const orderType = [1,4,2,3,6,5];
      getCandidateData = getCandidateData?.sort((a, b) => orderType.indexOf(a.id) - orderType.indexOf(b.id));
      // let agency = { id: 0, label: "Agency", value: "--" };
      // getCandidateData ? getCandidateData.push(agency) : [];
      return { stats: getCandidateData, totalData };
    },
    interviewEvents() {
      const t = this.getInterviewSlots
        .filter(
          (v) =>
            v?.selected_slot_date &&
            v?.selected_slot_start &&
            v?.selected_slot_end
        )
        .map((v) => {
          let start = new Date(v?.selected_slot_date);
          const startTimeSplit = v?.selected_slot_start.split(":");
          start.setHours(
            startTimeSplit[0],
            startTimeSplit[1],
            startTimeSplit[2]
          );

          let end = new Date(v?.selected_slot_date);
          const endTimeSplit = v?.selected_slot_end.split(":");
          end.setHours(endTimeSplit[0], endTimeSplit[1], endTimeSplit[2]);

          const title = v?.candidate?.full_name
            ? `Interview - ${v?.candidate?.full_name} | ${v?.job_display_uid} - ${v?.job?.job_title}`
            : "--";
          return {
            start: this.formatDate(start, "YYYY-MM-DD HH:mm"),
            end: this.formatDate(end, "YYYY-MM-DD HH:mm"),
            title,
            content: `Interviewer: ${v?.assigned_to_users_name}`,
            class: "leisure",
          };
        });
      return t;
    },
    isEducationalInstitute() {
      return (
        this.getCustomerTypeIDFromAccessToken ===
          CONST.CUSTOMER_TYPES.educational_institute || false
      );
    },
    // chartData() {
    //   const privateCandidateValue = this.getCandidateCourseCount?.private_candidate_count;
    //   const nonPrivateCandidateValue = this.getCandidateCourseCount?.not_private_candidate_count;

    //   return {
    //     // xAxisLabel: "Candidates",
    //     cdata: [
    //       { label: "Private Registrations", value: privateCandidateValue, backgroundColor: "#ff8c1a", borderColor: "#e67300" },
    //       { label: "Public Registrations", value: nonPrivateCandidateValue, backgroundColor: "#00ffcc", borderColor: "#00cccc" },
    //     ],
    //     barThickness: 50,
    //   };
    // },
    studentChartData() {
      const rows = this.getEduDashboardStats?.student ?? [];
      const palette = [
        { bg: "#4caf50", border: "#388e3c" },
        { bg: "#ffb300", border: "#ff8f00" },
        { bg: "#42a5f5", border: "#1e88e5" },
        { bg: "#ab47bc", border: "#8e24aa" },
        { bg: "#ec407a", border: "#d81b60" },
      ];

      return {
        cdata: rows.map((r, i) => ({
          label: r.candidate_type,
          value: Number(r.count ?? 0),
          backgroundColor: palette[i % palette.length].bg,
          borderColor: palette[i % palette.length].border,
        })),
        barThickness: 40,
      };
    },

    // Course chart
    courseChartData() {
      const rows = this.getEduDashboardStats?.course ?? [];
      const palette = [
        { bg: "#ff8c1a", border: "#e67300" },
        { bg: "#00bfa5", border: "#008e76" },
        { bg: "#29b6f6", border: "#0288d1" },
      ];

      return {
        cdata: rows.map((r, i) => ({
          label: r.course_name,
          value: Number(r.count ?? 0),
          backgroundColor: palette[i % palette.length].bg,
          borderColor: palette[i % palette.length].border,
        })),
        barThickness: 40,
      };
    },
    hasStudents() {
      return (
        this.isEducationalInstitute &&
        Array.isArray(this.getEduDashboardStats?.student) &&
        this.getEduDashboardStats.student.length > 0
      );
    },
    hasCourses() {
      return (
        this.isEducationalInstitute &&
        Array.isArray(this.getEduDashboardStats?.course) &&
        this.getEduDashboardStats.course.length > 0
      );
    },
    jobStatusChartData() {
      const colors = {
        Matched: "#6984ee",
        Shortlist: "#f2b759",
        "In Progress": "#949923",
        Vault: "#bf73a8",
      };
      const data = this.getTabTotalCounts?.map((v) => {
        return {
          name: v?.displayName,
          value: v?.count,
          color: colors[v?.displayName],
        };
      });
      return {
        series: [
          {
            type: "treemap",
            layoutAlgorithm: "squarified",
            data,
          },
        ],
        title: {
          text: "Job Sub Status",
        },
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchJobTotalCount",
      "getTotalCandidates",
      "getallshortliststatus",
      "getScratchPadItems",
      "fetchJobCandidateTabs",
      "jobCandidateTabTotalCount",
      "fetchUser",
      "fetchCandidateByTypeId",
      "fetchInterviewSlot",
      "scrollTop",
      "fetchCourseCount",
      "fetchEduDashboardStats",
    ]),
    handleTabChange(tabIndex) {
      this.tabIndex = tabIndex;
    },
    getRandomColor() {
      // Generate a random hex color
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    routeToCandidateList() {
      this.$router.push(FACILITY_CANDIDATE_URL);
    },
    getTheme(id) {
      let src = "";
      let color = "";
      switch (id) {
        case 0:
          src = "fas fa-clinic-medical";
          color = "#35c792;";
          break;
        case 1:
          src = "fas fa-user-md";
          color = "#8a08a2;";
          break;
        case 2:
          src = "fas fa-user-nurse";
          color = "#1973e8";
          break;
        case 3:
          src = "fas fa-notes-medical";
          color = "#61892F;";
          break;
        case 4:
          src = "fas fa-tooth";
          color = "#e01f66;";
          break;
        case 5:
          src = "fas fa-prescription-bottle-alt";
          color = "#B23850;";
          break;
        case 6:
          src = "fas fa-hospital";
          color = "#895061;";
          break;
        case 8:
          src = "img/job.png";
          color = "#8a08a2;";
          break;
        case 9:
          src = "img/group.png";
          color = "#dd3651;";
          break;
        case 10:
          src = "fa-solid fa-chalkboard-user";
          color = "#35c792;";
          break;
        case 11:
          src = "fa-solid fa-user-group";
          color = "#8a08a2;";
          break;
        case 12:
          src = "fa-solid fa-graduation-cap";
          color = "#61892F;";
          break;
        default:
          src = "fas fa-user-shield";
          color = "#9117a8;";
      }
      return {
        src: src,
        bg_color: "background-color: " + color,
        color: "color: " + color,
        text_color: "color: " + color,
        raw_color: `${color.replace(";", "")} !important;`,
      };
    },
    iconHide(id) {
      if (id == 8 || id == 9) return false;
      return true;
    },
    formatDate(date, format) {
      return m(date).format(format) || "--";
    },
  },
  created() {
    this.scrollTop();
    let appendAction = [];
    let appendConfigAction;
    if (!(isObject(this.getUser) && !isEmptyObjectCheck(this.getUser))) {
      // DUPLICATE API TRIGGER REMOVED: this.fetchUser()
      // appendAction = [...appendAction, this.fetchUser()];
      appendAction = [...appendAction];
    }
    Promise.all(appendAction).then((res) => {
      if (this.isEducationalInstitute) {
        const payload = {
          customer_uid: this.getCustomerId,
          organisation_id: this.getOrgID,
        };
        this.fetchCourseCount(payload);
      } else {
        this.fetchJobTotalCount(this.getCustomerId);
        this.jobCandidateTabTotalCount(this.getCustomerId);
      }
      this.getTotalCandidates(this.getCustomerId);
      this.fetchCandidateByTypeId();
      this.fetchInterviewSlot();
      this.fetchEduDashboardStats();
    });
  },
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 450px) {
  .tile {
    margin-top: 20px;
  }
}

.maintainwidth {
  min-width: 158px;
}
.text-value {
  width: max-content;
  img,
  i {
    vertical-align: middle;
    border-style: none;
    float: left;
    height: 27px;
    font-size: 27px;
    margin-top: 6px;
    margin-right: 16px;
  }
}
.widget-v2 {
  .border-4 {
    --bs-border-width: 4px;
  }
  .shadow-1,
  .popover,
  .card-raised {
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  }
  .small,
  .toast,
  .card,
  .alert {
    letter-spacing: 0.0178571429em;
    font-size: 0.875rem;
  }
  .card {
    line-height: 1.25rem;
    color: #000;
  }
  .card-raised {
    border: none !important;
  }
  .card-body {
    flex: 1 1 auto;
    padding: 1rem 1rem;
  }
  .border-start {
    border-left: 4px solid #e0e0e0 !important;
  }
  // .border-primary {
  //   border-color: rgba(98, 0, 234, 1) !important;
  // }
  .icon-i {
    font-size: 27px;
  }
  .icon-img {
    height: 27px;
    font-size: 27px;
    margin-top: 6px;
    margin-right: 16px;
  }
  .card-text {
    font-size: 13px;
  }
  .display-5 {
    font-size: 20px;
  }
}
</style>
